<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 4C14.0004 4 15.8485 4.65266 17.3427 5.75666L17.2929 5.70711C16.9024 5.31658 16.9024 4.68342 17.2929 4.29289C17.6534 3.93241 18.2206 3.90468 18.6129 4.2097L18.7071 4.29289L20.7071 6.29289C21.0976 6.68342 21.0976 7.31658 20.7071 7.70711C20.3466 8.06759 19.7794 8.09532 19.3871 7.7903L19.2929 7.70711L19.2433 7.65729C20.3473 9.15154 21 10.9996 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4ZM12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6ZM12 8C12.5523 8 13 8.44772 13 9V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V9C11 8.44772 11.4477 8 12 8ZM15 2C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H9C8.44772 4 8 3.55228 8 3C8 2.44772 8.44772 2 9 2H15Z"
    fill="currentColor"
  />
</svg>
